import React, { FC, useCallback } from 'react'

import { useAsyncLoader } from '@aboutyou/legacy-shared/src/utils/hooks/useAsyncLoader'
import { TrackingRecoSectionContext } from '@aboutyou/legacy-tracking-sdk'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useService } from 'services/utils/context'
import { HeadingM } from 'uiComponents/atoms/Text/Headings'
import ProductRecoSlider from './ProductRecoSlider'

interface IWishlistProductRecoProps {
  productIds: number[]
  trackingRecoTitle?: string
  recoType: TrackingRecoSectionContext['recoType']
}

const slideCounts = {
  slideCount: 3,
  slideCountMedium: 4,
  slideCountLarge: 4,
}

const WishlistProductReco: FC<IWishlistProductRecoProps> = ({
  productIds,
  recoType,
}) => {
  const [t] = useTranslation()
  const service = useService()
  const products = useAsyncLoader(
    useCallback(
      () => service.products.requestProductsByIds(productIds.map(String)),
      [productIds],
    ),
  )

  if (!Array.isArray(products)) {
    return null
  }

  const title = t('Nicht vergessen! Produkte auf Deiner Wunschliste')

  return (
    <ProductRecoSlider
      products={products.filter(product => product.isActive)}
      title={<HeadingM data-testid="HeadlineText">{title}</HeadingM>}
      slideCounts={slideCounts}
      dataTestId="WishlistReminderSlider"
      constrained
      recoType={recoType}
      trackingRecoTitle={title}
      maxNumProducts={12}
    />
  )
}

export default WishlistProductReco
